// 👉 swipe fix mobile product cards
document.querySelectorAll('.product-card-slider').forEach(slider => {
  let startX = 0;
  let isSwiping = false;

  slider.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isSwiping = false;
  });

  slider.addEventListener('touchmove', (e) => {
    const moveX = e.touches[0].clientX;
    if (Math.abs(moveX - startX) > 10) {
      isSwiping = true;
    }
  });

  slider.addEventListener('click', (e) => {
    if (isSwiping) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
});